import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatRipple } from '@angular/material/core';
@Component({
  selector: 'ihm-expansion-button',
  templateUrl: './ihm-expansion-button.component.html',
  styleUrls: ['./ihm-expansion-button.component.scss']
})
export class IhmExpansionButtonComponent implements OnInit {
  public isOpenValue: boolean;

  @ViewChild(MatRipple) expansionIconRipple: MatRipple;
  @ViewChild(MatButton) expansionButton: MatButton;

  @Input()
  public readonly message: string;

  @Input()
  public isOpen: boolean;

  @Input()
  public readonly showWarning: boolean;

  @Input()
  public readonly warningLevel: string = 'warning';

  @Input()
  public readonly color: string = 'blue';

  @Input()
  public readonly arrowDirection: string = 'left';

  @Output()
  public readonly toggle = new EventEmitter<boolean>();

  constructor() {}

  public ngOnInit(): void {
    this.isOpenValue = this.isOpen;
  }

  public onClick(): void {
    this.isOpenValue = !this.isOpenValue;
    this.expansionIconRipple.launch({ centered: false });
    this.expansionButton.ripple.launch({ centered: false });

    this.toggle.emit(this.isOpenValue);
  }
}
